import { render } from "./B2bTableMenuAccountingCloseDraft.vue?vue&type=template&id=c8abbc6a&scoped=true&lang=pug"
import script from "./B2bTableMenuAccountingCloseDraft.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuAccountingCloseDraft.vue?vue&type=script&lang=js"

import "./B2bTableMenuAccountingCloseDraft.vue?vue&type=style&index=0&id=c8abbc6a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8abbc6a"]])

export default __exports__